export const tr = {
    'autobudget-priority': 'Öncelik',
    banners: 'Reklamlar',
    'campaign-group': 'Kampanya/Grup',
    cpa: 'CPA, {currency}',
    cpc: 'CPC, {currency}',
    name: 'Ad',
    price: 'Reklamdaki fiyat',
    status: 'Durum',
    'target-funnel': 'Hedef kitle'
};
